import React from "react";

export default function FGCard({ item, isFirst }) {
  return (
    <div 
      className="fg-card" 
      style={{
        padding: '16px', /* Increased for look-and-feel readability */
        width: '100%', 
        minHeight: '110px', /* Shifted from strict static height to elastic minimum boundary */
        borderTop: isFirst ? 'none' : '1px solid #e2e8f0',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', 
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.02)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
      }}
    >
      <p style={textStyle}><b>FG:</b> {item.fgNumber}</p>
      <p style={textStyle}><b>DO:</b> {item.doNumber || "—"}</p>
      <p style={textStyle}><b>Label:</b> {item.labelType || "—"} — Qty {item.quantity || 0}</p>
      
      {item.delayed && (
        <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center' }}> 
          <span style={{
            color: '#b91c1c', 
            backgroundColor: '#fee2e2',
            fontSize: '12px', 
            fontWeight: '700',
            padding: '4px 10px',
            borderRadius: '6px',
            display: 'inline-block'
          }}>
            Delayed: {item.delayed} days
          </span>
        </div>
      )}
    </div>
  );
}

const textStyle = {
  margin: '0 0 6px 0',
  fontSize: '14px',
  whiteSpace: 'normal', /* Allows text wrapping on narrow device screens */
  wordBreak: 'break-word',
  color: '#334155',
  lineHeight: '1.4'
};